import type {RouteLocationNormalized} from 'vue-router';

export const isValidRieId = (rieId?: unknown): boolean => {
	const id = Number(rieId);
	return !isNaN(id) && id > 0;
};

export const isValidRieIdParam = (route: RouteLocationNormalized): boolean => {
	return isValidRieId(route?.params?.rieId);
};
